<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="report"
                 :report="report"
                 class="main-content"/>
    <div v-else-if="loadError" class="main-content p-4">
      Unable to load this report.
    </div>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  IfacAwardDetails,
  IfacNominationDetails,
  IfacNominationReferences,
  IfacNominationReviews,
  handleAuthorization,
} from '@ifac/ui';
import reportsMixin from '@/mixins/awards/reports.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';
import { mapGetters } from 'vuex';
import Reports from '@/services/Api/Awards/Reports';

export default {
  mixins: [reportsMixin],
  name: 'ReportsEditPortal',
  components: {
    ParentPortal,
  },
  created() {
    this.fetchReport();
  },
  data() {
    return {
      review: null,
      report: null,
      loadError: false,
    };
  },
  methods: {
    fetchReport() {
      this.loadError = false;

      const params = {
        relations: ['reportable'],
      };

      Reports.get(this.reportId, params)
        .then((response) => {
          this.report = response.data.data;
        })
        .catch((error) => {
          handleAuthorization(error).then((msg) => {
            if (msg) {
              this.$snack.success({ text: msg });
            }
          });

          this.loadError = true;
        });
    },
  },
  computed: {
    reportId() {
      return this.$route.params.report;
    },
    ...mapGetters({
      user: 'auth/user',
    }),
    sidePanelComponents() {
      if (!this.report) {
        return [];
      }

      const award = this.report.reportable_type === 'nomination'
        ? this.report.reportable.award
        : this.report.reportable;

      const tabs = [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award,
            isLoading: false,
          },
        },
      ];

      // Nomination
      if (this.report.reportable_type === 'nomination') {
        tabs.push({
          icon: ['far', 'user-check'],
          headerText: 'Nomination',
          component: IfacNominationDetails,
          options: {
            nomination: this.report.reportable,
            isLoading: false,
          },
        });

        // Reference Letters
        if (this.report.reportable.can.viewReferences) {
          tabs.push({
            icon: ['far', 'envelope'],
            headerText: 'Reference letters',
            component: IfacNominationReferences,
            options: {
              nomination: this.report.reportable,
              isLoading: false,
            },
          });
        }

        if (this.report.reportable.can.viewReviews) {
          tabs.push({
            icon: ['far', 'file-check'],
            headerText: 'Reviews',
            component: IfacNominationReviews,
            options: {
              nomination: this.report.reportable,
              isLoading: false,
            },
          });
        }
      }

      return tabs;
    },
  },
  watch: {
    reviewId() {
      this.fetchReview();
    },
  },
};
</script>
